import OnlineUsage from './component';

export default {
  path: 'online-usage(/:mode/:studentId)',
  component: OnlineUsage,
};



// WEBPACK FOOTER //
// ./containers/Group/Homework/OnlineUsage/routes.js